module.exports = __webpack_public_path__ + "static/6-87e0d21a878903ed1055a9d7811710c5.jpeg";